/**
 * API Utility Functions
 * Centralized API calls for the frontend
 */

import axios from 'axios';

const API_URL = 'https://siragupathipagam.onrender.com/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Fetch all eBooks
 */
export const fetchEbooks = async () => {
  try {
    const response = await apiClient.get('/ebooks');
    return response.data;
  } catch (error) {
    console.error('Error fetching eBooks:', error);
    throw error;
  }
};

/**
 * Add new eBook (Admin)
 */
export const addEbook = async (ebookData) => {
  try {
    // Create a separate axios instance for multipart uploads
    const uploadClient = axios.create({
      baseURL: API_URL,
    });

    const response = await uploadClient.post('/ebooks', ebookData);
    console.log('Add eBook response:', response);
    
    // Return the response data which contains success and data
    if (response.data) {
      return response.data;
    }
    return response;
  } catch (error) {
    console.error('Error adding eBook:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

/**
 * Record download
 */
export const recordDownload = async (downloadData) => {
  try {
    const response = await apiClient.post('/download', downloadData);
    return response.data;
  } catch (error) {
    console.error('Error recording download:', error);
    throw error;
  }
};

/**
 * Get download stats for an eBook
 */
export const getDownloadStats = async (ebookId) => {
  try {
    const response = await apiClient.get(`/download-stats/${ebookId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching download stats:', error);
    throw error;
  }
};

/**
 * Delete an eBook
 */
export const deleteEbook = async (ebookId) => {
  try {
    const response = await apiClient.delete(`/ebooks/${ebookId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting eBook:', error);
    throw error;
  }
};

export default apiClient;
